/*
Here keys are the ids of the section

This names are for the analytics 
*/

const SectionNames = {
    'home': 'Home Section',
    'demat': 'Open Demat Account Section',
    'easy-steps': '3 Easy Steps Section',
    'what-you-get': 'What You Get Section',
    'market-mantra': 'Stock Market Mantra Section',
    'options': 'Investing Options Section',
    'services': 'We\'ve Got You Covered Section',
    'about-me': 'About Me Section',
    'testimonials': 'Testimonials Section',
    'contact-me': 'Contact Me Section',
    'sip-calculator': 'Sip Calculator Section',
    'quote': 'Quotes Section',
    '404' : 'Page Not Found Section'
  };
  
  export default SectionNames;
  